/* GENERATED from storefront-overlays.src.js by build/gen_js.py - do not edit.
   The commented source is storefront-overlays.src.js. */
(function () {
'use strict';
var root = document.documentElement;
var consent, sticky, frame = 0;
var resize = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(schedule) : null;
var attributes = new MutationObserver(schedule);
function height(node, shown) {
return node && shown && !node.hidden ? Math.ceil(node.getBoundingClientRect().height) : 0;
}
function measure() {
frame = 0;
var consentHeight = height(consent, true);
var stickyHeight = height(sticky, sticky && sticky.classList.contains('on'));
root.style.setProperty('--sf-consent-height', consentHeight + 'px');
root.style.setProperty('--sf-sticky-height', stickyHeight + 'px');
root.style.setProperty('--sf-overlay-stack', (consentHeight + stickyHeight) + 'px');
var floor = window.innerHeight - consentHeight - stickyHeight;
var actionClear = Array.prototype.some.call(document.querySelectorAll('.collection-main__bar, .pf-hero__cta, .loc-page h2, .loc-page summary, .loc-page .lp-btn, .loc-page .lp-feature, .store-finder a, .store-finder h2, .store-finder p, .store-finder summary, .store-finder address, .store-finder h3'), function (node) {
var bar = node.getBoundingClientRect();
return bar.bottom > floor - 96 && bar.top < floor;
});
document.body.classList.toggle('sf-toolbar-clear', actionClear);
}
function schedule() {
if (!frame) frame = requestAnimationFrame(measure);
}
function connect() {
attributes.disconnect();
if (resize) resize.disconnect();
consent = document.getElementById('ConsentBanner');
sticky = document.querySelector('[data-sticky-atc]');
[consent, sticky].forEach(function (node) {
if (!node) return;
attributes.observe(node, {attributes:true, attributeFilter:['hidden','class']});
if (resize) resize.observe(node);
});
schedule();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, {once:true});
else connect();
document.addEventListener('shopify:section:load', connect);
window.addEventListener('resize', schedule, {passive:true});
window.addEventListener('scroll', schedule, {passive:true});
if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, {passive:true});
}());
